import { isEmpty } from 'lodash';
import React from 'react';
import { Row } from 'react-table';
import AnimatedSponsor from '../../components/AnimatedSponsor/AnimatedSponsor';
import { CLASS_PREFIX } from '../../config';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { IDataProps } from '../../types';
import { activityCellInfo, classList, hasSponsors } from '../../util/util';
import usePollsLeftMap from '../../hooks/usePollsLeftMap';
interface IRenderRow {
  index: number;
  row: Row<IDataProps>;
}

const BasstrakkTableRenderRow = (props: IRenderRow) => {
  const [pollsLeftMap] = usePollsLeftMap();
  const { index, row } = props;
  const { original: angler } = row;

  const { width } = useWindowDimensions();

  // When a row is expanded to show the Angler's information we want to
  // change the color of the row.
  const expandedRowColor = row.isExpanded
    ? { style: { background: '#f9ba5e' } }
    : {};

  const stripingClass = index % 2 ? 'even' : 'odd';

  return (
    <div
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      {...row.getToggleRowExpandedProps(expandedRowColor)}
      key={`basstrakk-${row.id}`}
      className={classList(
        `${CLASS_PREFIX}row row-index-${row.index} index-${index}`,
        `angler-${angler.FISHERMENID.toString()}`
      )}
    >
      {row.cells.map(cell => {
        const lastCatch = angler.Catches.slice(-1)[0];

        // Where did we get this...ingest/src/server.js
        const BASSTRAKK_POLL_TIME = 30;
        // Activity cell catch
        const pollsLeft = pollsLeftMap.get(lastCatch?.uid) ?? 0;

        // Indexed array
        const logos = angler.sponsorLogos;
        // This relates to the index in the sponsorLogos array
        let target = BASSTRAKK_POLL_TIME - pollsLeft;
        // PollsLeft decrements every 10 seconds but we want to switch
        // sponsors every 20 seconds. Ignore the first target of 0 and after
        // that we switch sponsors every time PollsLeft is reduced by 2.
        target = (pollsLeft % 2) ? (target - 1) / 2 : target / 2;

        const pollHasEnded = Boolean(target >= logos.length);
        const { catchText } = activityCellInfo(angler.PollsLeft);
        let addActiveCatchClass = false;

        // We want to render a sponsor if the have a catch, they have
        // sponsors, and we are rendering the "Activity" column
        const shouldRenderSponsor: boolean =
          !isEmpty(lastCatch) &&
          hasSponsors(row, pollsLeft) &&
          !pollHasEnded &&
          cell.column.Header === 'Activity';

        if (shouldRenderSponsor) {
          addActiveCatchClass = true;
        }

        const cellClass = addActiveCatchClass
          ? 'active-catch sponsored-catch--relative'
          : 'sponsored-catch--relative';
        // Combine props
        const styleProps = cell.getCellProps();
        const goldenAngler = row.isExpanded ? { background: '#f9ba5e' } : {};
        const newProps = { ...styleProps.style, ...goldenAngler };
        return (
          <div
            {...cell.getCellProps()}
            style={newProps}
            className={classList(
              (cell.column as any).className,
              stripingClass,
              cellClass
            )}
          >
            {/* You can pass extra parameters to the cell as a second argument to render() */}
            {cell.render('Cell', { index, width })}
            {shouldRenderSponsor && !pollHasEnded ? (
              <AnimatedSponsor
                sponsors={logos}
                text={catchText}
                weight={lastCatch.FishWeightPdsOz}
                target={target}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default BasstrakkTableRenderRow;
